var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-container"},[_c('keep-alive',[_c(_vm.selectedMode,{tag:"component",attrs:{"selectedOffice":_vm.selectedOffice,"isHistoryMode":_vm.isHistoryMode}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }